module.exports = __webpack_public_path__ + "media/images/resource-placeholder-fca0328630b74a820f9b1172b279723c.svg";